import styled from "styled-components";
import Alert from "react-bootstrap/Alert";

export const StyledAlert = styled(Alert)`
  /* background: ${({ $alertBackground }) =>
    $alertBackground
      ? $alertBackground === "success"
        ? "#3BAA28"
        : "var(--tertiary-color)"
      : "var(--danger-color)"}; */
  background: ${({ $alertBackground }) =>
    $alertBackground ? $alertBackground : "var(--tertiary-color)"};
  width: 400px;
  min-height: 70px;
  position: fixed;
  top: ${({ $isModal }) => ($isModal ? "50%" : "70px")};
  left: 50%;
  z-index: 10000;
  transform: translate(-50%);
  font-weight: 500;
  font-size: var(--font-size-sm);
  text-align: center;
  border: 2px solid var(--white-color);
  border-radius: 18px;
  color: var(--white-color);
  color: ${({ $isModal }) =>
    $isModal ? "var(--text-color-dark)" : "var(--white-color)"};
  @media screen and (max-width: 576px) {
    width: 300px;
  }
  .top-line {
    position: absolute;
    top: 5px;
    left: 5px;
  }
  .bottom-line {
    position: absolute;
    bottom: 5px;
    right: 5px;
    transform: rotate(180deg);
  }
`;
